export const AUCUN = 'Aucun';
export const BLOQUE = 'Bloque';
export const OPTION = 'Option';
export const SANS_SUITE = 'SansSuite';
export const ANNULATION = 'Annulation';
export const INDISPONIBLE = 'Indisponible';
